import React, { useState, useEffect } from 'react'
import $, { param } from 'jquery';
import notificationSVG from '../../asset/Images/notification-text.svg';
import dotsSVG from '../../asset/Images/dots-vertical.svg';
import arrowUPSVG from '../../asset/Images/arrow-up.svg';
import arrowdownSVG from '../../asset/Images/arrow-down.svg';
import { getAssetReturns } from '../../actions/assetDetailsActions';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { UrlPath } from '../../../config/routeConfig';
import { getAssetSettings } from '../../actions/assetSettingsAction';
import closePng from '../../asset/Images/close-icon.png';
import { getAsset } from '../../actions/assetAction';
import { LoadingScreen } from '../../UiComponents/LoadingComponent';
import noDataAvailable from '../../../Images/noDataAvailable.svg';

const defaultReturns = [
    {
        "EntityName": "",
        "Period": "MTD",
        "PeriodValue": "",
        "AsofDate": ""
    },
    {
        "EntityName": "",
        "Period": "QTD",
        "PeriodValue": "",
        "AsofDate": ""
    },
    {
        "EntityName": "",
        "Period": "YTD",
        "PeriodValue": '',
        "AsofDate": ""
    }
];
export const AssetReturnsList = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const returnDetails = useSelector((state) => state.assetReturns.assetReturns);
    const isReturnsLoading = useSelector((state) => state.assetReturns.assetReturnsLoad);
    useEffect(() => {
        //dispatch(getAsset(params.Asset));
        dispatch(getAssetReturns(params.Asset, '1'));
        dispatch(getAssetSettings(params.Asset, 1));
    }, []);
    const Gstate = useSelector((state) => state);
    const AssetSettings = useSelector(state => state.assetSettings);
    const currentAsset = Gstate.asset.asset || {};
    const BM1 = currentAsset.PrimaryBM ? currentAsset.PrimaryBM : "";
    const BM2 = currentAsset.SecondaryBM ? currentAsset.SecondaryBM : "";
    const AssetName = currentAsset.AssetName;
    const [selectedBM1, setSelectedBM1] = useState(defaultReturns);
    const [selectedBM2, setSelectedBM2] = useState(defaultReturns);
    const [assetReturn, setAssetReturn] = useState(defaultReturns);
    const [isAssetRtnAvailable, setIsAssetRtnAvailable] = useState(false);
    const [returnLoader, setReturnsLoader] = useState(isReturnsLoading);
    useEffect(() => {
        const Assetitem = returnDetails?.filter(item => item.EntityName ? item.EntityName === AssetName : "") || [];
        const BM1item = returnDetails?.filter(item => item.EntityName ? item.EntityName === BM1 : "") || [];
        const BM2item = returnDetails?.filter(item => item.EntityName ? item.EntityName === BM2 : "") || [];
        if (Assetitem.length > 0) {
            setAssetReturn(Assetitem);
            setIsAssetRtnAvailable(true);
        }
        else {
            setAssetReturn(defaultReturns);
            setIsAssetRtnAvailable(false)
        }
        if (BM1item.length > 0) setSelectedBM1(BM1item); else setSelectedBM1(defaultReturns);
        if (BM2item.length > 0) setSelectedBM2(BM2item); else setSelectedBM2(defaultReturns);
        if (isReturnsLoading) setReturnsLoader(isReturnsLoading); else setReturnsLoader(false);
    }, [returnDetails, isReturnsLoading]);
    console.log(isAssetRtnAvailable)
    return (
        <>
            {!returnLoader && <>
                {isAssetRtnAvailable ?
                    <div class="col-md-6 col-lg-4">
                        <div class="card" style={{ width: "300%" }}>
                            <div class="card-body p-0 w-100 overflow-auto returns">
                                <table class="table table-borderless">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th class="fw-medium">Asset</th>
                                            <th class="fw-medium">{"Benchmark 1"}</th>
                                            <th class="fw-medium">{"Benchmark 2"}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <GetBenchMarkRow type={"MTD"} Asset={assetReturn} BM1={selectedBM1} BM2={selectedBM2} />
                                        </tr>
                                        <tr>
                                            <GetBenchMarkRow type={"QTD"} Asset={assetReturn} BM1={selectedBM1} BM2={selectedBM2} />
                                        </tr>
                                        <tr>
                                            <GetBenchMarkRow type={"YTD"} Asset={assetReturn} BM1={selectedBM1} BM2={selectedBM2} />
                                        </tr>
                                    </tbody>
                                </table> </div>
                        </div>
                    </div> : <>  <div className='d-flex w-100 my-4 h-100'>
                                <img src={noDataAvailable} alt='NO DATA AVAILABLE' className='m-auto' width={'30%'}/>
                                </div></>}</>}

        </>
    )
}

const GetBenchMarkRow = ({ type, Asset, BM1, BM2 }) => {
    const AssetData = Asset.find(item => item.Period === type);
    const BM1Data = BM1.find(item => item.Period === type);
    const BM2Data = BM2.find(item => item.Period === type);
    return <>
        <td>{type}</td>
        <GetBenchMarkCell item={AssetData} />
        <GetBenchMarkCell item={BM1Data} />
        <GetBenchMarkCell item={BM2Data} />
    </>
}
const GetBenchMarkCell = ({ item }) => {
    return <td><span style={{ textAlign: "right" }}>{item.PeriodValue ? ' ' + (item.PeriodValue * 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }) + '%' : 'NA'}
    </span><span>{item.PeriodValue > 0 ? <img class="ms-1"
        src={arrowUPSVG} alt="Arrow-Up" /> : <>{item.PeriodValue == "" ? <></> : <> <img class="ms-1"
            src={arrowdownSVG}
            alt="Arrow-Up" /></>}</>
    } </span></td>
}
